import { isFile } from 'utils/files/isFile'

import defaultPostThumbnail from 'assets/images/defaultPostThumbnail.png'

import { FileType, NativeVideoFile, SelectedFile } from 'types/file'
import { Media } from 'types/media'

export const getFileTypeFromMimeType = (mimeType: string | undefined): FileType => {
  if (!mimeType) {
    return 'unknown'
  }

  if (mimeType.includes('image')) {
    return 'image'
  }

  if (mimeType.includes('video')) {
    return 'video'
  }

  return 'unknown'
}

export const getMimeTypeAndFileFromFileOrMedia = (
  media: SelectedFile | Media,
): {
  mediaMimeType: string
  mediaToUpload: string | File | NativeVideoFile
} => {
  let mediaMimeType: string
  let mediaToUpload: string | File | NativeVideoFile
  if (isFile(media)) {
    if ('lastModified' in media) {
      mediaToUpload = media
      mediaMimeType = media.type
    } else {
      if (media.cancelled || !media.mimeType) {
        throw new Error('Media upload failed, or unknown file type')
      }
      if (media.base64) {
        mediaToUpload = `data:${media.mimeType};base64,${media.base64}`
      } else {
        mediaToUpload = {
          name: 'upload.mp4',
          uri: media.uri,
          type: media.mimeType,
        }
      }

      mediaMimeType = media.mimeType
    }
  } else {
    mediaToUpload = media.url
    mediaMimeType = media.mimeType
  }

  return { mediaToUpload, mediaMimeType }
}

export const defaultPostThumbnailUrl = defaultPostThumbnail
